import { Button, Input } from "@material-ui/core";
import { PaymentListItem, PaymentListItemBatch } from "../../interface";
import OptionalNumericInput from "./optional-numeric-input";
import OptionalTextInput from "./optional-text-input";

interface OptionsCellProps {
    config: PaymentListItem;
    batch: PaymentListItemBatch | null;
    setBatch: (batch: PaymentListItemBatch | null) => void;
    min: number | null;
    setMin: (min: number | null) => void;
    max: number | null;
    setMax: (max: number | null) => void;
    mod: number | null;
    setMod: (mod: number | null) => void;
    title: string | null;
    setTitle: (title: string | null) => void;
    caption: string | null;
    setCaption: (caption: string | null) => void;
    bonus: number | null;
    setBonus: (bonus: number | null) => void;
    cancel_timer: number | null;
    setCancelTimer: (cancel_timer: number | null) => void;
};

const OptionsCell = ({ config, batch, setBatch, min, setMin, max, setMax, mod, setMod, title, setTitle, caption, setCaption, bonus, setBonus, cancel_timer, setCancelTimer}: OptionsCellProps) => {
    return <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
        {config.options.batch && <><Button size="small" variant="contained" onClick={() => {
            if (!batch) {
                setBatch({ fullTime: 3 * 60, period: 10 });
            } else {
                setBatch(null);
            }
        }}>{batch ? "Выключить" : "Включить"} автодозвон</Button>
            {batch && <div style={{ display: "flex", flexDirection: "column" }}>
                <label>Время дозвона (сек) <Input type="number" value={batch.fullTime} onChange={e => setBatch({ ...batch, fullTime: +e.target.value })} /></label>
                <label>Интервал между запросами (сек) <Input type="number" value={batch.period} onChange={e => setBatch({ ...batch, period: +e.target.value })} /></label>
            </div>}
        </>}
        <OptionalNumericInput
            value={min}
            setValue={setMin}
            initialValue={config.min}
            setButtonText="Задать минимальную сумму"
            resetButtonText="Сбросить минимальную сумму"
            labelText="Минимальная сумма"
        />
        <OptionalNumericInput
            value={max}
            setValue={setMax}
            initialValue={config.max}
            setButtonText="Задать максимальную сумму"
            resetButtonText="Сбросить максимальную сумму"
            labelText="Максимальная сумма"
        />
        <OptionalNumericInput
            value={mod}
            setValue={setMod}
            initialValue={config.mod}
            setButtonText="Задать кратность"
            resetButtonText="Сбросить кратность"
            labelText="Кратность в копейках"
        />
        <OptionalTextInput
            value={title}
            setValue={setTitle}
            initialValue={config.title ?? ""}
            setButtonText="Задать заголовок"
            resetButtonText="Сбросить заголовок"
            labelText="Заголовок"
        />
        <OptionalTextInput
            value={caption}
            setValue={setCaption}
            initialValue={config.caption ?? ""}
            setButtonText="Задать подпись"
            resetButtonText="Сбросить подпись"
            labelText="Подпись"
        />
        <OptionalNumericInput
            value={bonus}
            setValue={setBonus}
            initialValue={config.bonus ?? null}
            setButtonText="Задать бонус"
            resetButtonText="Сбросить бонус"
            labelText="Бонус"
        />
        <OptionalNumericInput
            value={cancel_timer}
            setValue={setCancelTimer}
            initialValue={config.cancel_timer ?? null}
            setButtonText="Кнопка отмены через"
            resetButtonText="Сбросить отмену"
            labelText="Отмена через(сек)"
        />
    </div>
}

export default OptionsCell;